var map = {
	"./placeholder-0.svg": 596,
	"./placeholder-1.svg": 597,
	"./placeholder-2.svg": 598,
	"./placeholder-3.svg": 599,
	"./placeholder-4.svg": 600,
	"./placeholder-5.svg": 601
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 595;